import React, { ReactElement, useCallback } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import logo from '@assets/images/logo.svg';
import classes from './AuthCard.module.scss';
import { ReactComponent as ArrowLeft } from '@assets/images/prev-arrow.svg';

type AuthCardProps = {
  title?: string;
  showBackButton?: boolean;
  children?: JSX.Element | JSX.Element[];
  stepProgressBar?: ReactElement | ReactElement[];
  showTopLogo?: boolean;
  className?: string;
};

const AuthCard = ({
  title,
  showBackButton,
  children,
  stepProgressBar,
  showTopLogo = true,
  className,
}: AuthCardProps) => {
  const navigate = useNavigate();

  const navigateBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div data-testid={'auth-card'} className={classNames(classes.authCard, className)}>
      {(!!showBackButton || !!showTopLogo) && (
        <div className={classes.authCardHeader}>
          {!!showBackButton && (
            <span aria-hidden onClick={navigateBack} className={classes.backButton}>
              <ArrowLeft fill={'#C7C7CC'} width={12} height={20} />
              Back
            </span>
          )}
          {!!showTopLogo && <img src={logo} alt="Airdrop.com" />}
        </div>
      )}
      {stepProgressBar && <div className={classes.stepProgressBar}>{stepProgressBar}</div>}
      {title && <h3 className={classes.title}>{title}</h3>}
      <div className={classes.authCardMain}>{children}</div>
    </div>
  );
};

export default AuthCard;
